import { useState } from "react";
import "../../styles/Frontend/components.scss";

const Calculator = () => {
  const [plan, setPlan] = useState("");
  const [amount, setAmount] = useState("");
  const [income, setIncome] = useState("");
  const [estimate, setEstimate] = useState("");
  const [calc, setCalc] = useState(false);
  const [errMsg, setErrMsg] = useState(false);

  const handleChangeAmount = (e) => {
    e.preventDefault();
    setAmount(e.target.value);

    setIncome(amount * 10);
  };
  const handleChangePlan = (e) => {
    e.preventDefault();
    setPlan(e.target.value);
  };

  const calculate = (e) => {
    e.preventDefault();

    if (plan === "") {
      setErrMsg("Choose Plan");
      return;
    } else if (amount < 1000) {
      setErrMsg("Minimum investment is $500");
      return;
    } else if (plan === "240" && (amount < 1000 || amount > 3999)) {
      setErrMsg("Basic Plan is between $1000 - $3,999");
      return;
    } else if (plan === "275" && (amount < 4000 || amount > 11999)) {
      setErrMsg("Gold Plan is between $4,000 - $11,999");
      return;
    } else if (plan === "310" && (amount < 12000 || amount > 49999)) {
      setErrMsg("Platinum Plan is between $12,000 - $49,999");
      return;
    } else if (plan === "380" && amount < 50000) {
      setErrMsg("Diamond Plan is above $50,000");
      return;
    }

    const totalIncome = amount * (plan / 100);

    const estimatedProfit = totalIncome - amount;

    setIncome(totalIncome.toLocaleString());
    setEstimate(estimatedProfit.toLocaleString());

    setCalc(true);
  };

  return (
    <div className="calculator">
      <div className="calc-wrapper">
        <form action="" className="row">
          <h5 className="text-dark mb-4">Profit Calculator</h5>

          <div className={`${errMsg ? "d-flex" : "d-none"} error-message`}>
            <i className="fas fa-exclamation-triangle mx-3"></i>
            <p>{errMsg}</p>
          </div>
          <div className="col-lg-6">
            <label htmlFor="plan">Choose Plan</label>
            <select
              className="form-select"
              id="plan"
              onChange={handleChangePlan}
              value={plan}
              onFocus={() => {
                setCalc(false);
                setErrMsg(false);
              }}
            >
              <option value="">Choose Plan</option>
              <option value="240">Basic</option>
              <option value="275">Gold</option>
              <option value="310">Platinum</option>
              <option value="380">Diamond</option>
            </select>
          </div>

          <div className="col-lg-6">
            <label htmlFor="amount-calc">Amount</label>
            {/* <p>USD</p> */}
            <input
              id="amount"
              type="text"
              className="form-control"
              placeholder="0.00"
              value={amount}
              onChange={handleChangeAmount}
              onFocus={() => {
                setCalc(false);
                setErrMsg(false);
              }}
              required
            />
          </div>

          <div className="profit">
            <div className="profit-wrapper">
              {calc ? (
                <>
                  <div className="estimate result">
                    <small>Estimated Profit</small>
                    <h4 className="text-primary">${estimate}</h4>
                  </div>
                  <div className="total result">
                    <small>Total Income</small>
                    <h4 className="text-primary">${income}</h4>
                  </div>
                </>
              ) : (
                <button onClick={calculate} className="btn calc-btn">
                  SHOW ESTIMATED PROFIT
                </button>
              )}
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Calculator;
